import React from 'react';

// [PATCH stevilke-locila v1] tisociska pika za prikaz (1.000,00), telo identicno DokumentiPage fmt
const fmtTis = (n: number) => { const x = Number(n||0).toFixed(2); const [c, d] = x.split('.'); return c.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d; };

interface Props {
  value: number;
  onChange: (v: number) => void;
  className?: string;
  bold?: boolean;
  id?: string;        // [PATCH rocni-vnos-fe v1]
  tabIndex?: number;  // [PATCH rocni-vnos-fe v1]
  napaka?: string;    // [PATCH likvidacija-fe v3] rdeca obroba + tooltip, ko glava ne sede (osnova+DDV != skupaj)
}

export function ZnesekInput({ value, onChange, className = '', bold = false, id, tabIndex, napaka }: Props) {
  const [raw, setRaw] = React.useState<string|null>(null);
  
  const displayed = raw !== null ? raw : fmtTis(value); // [PATCH stevilke-locila v1] prikaz s tisocicami; raw med urejanjem gol

  return (
    <input
      id={id} tabIndex={tabIndex} title={napaka || undefined}
      type="text"
      value={displayed}
      onFocus={e => {
        setRaw(Number(value||0).toFixed(2).replace('.', ','));
        setTimeout(()=>e.target.select(), 0);
      }}
      onChange={e => setRaw(e.target.value)}
      onBlur={e => {
        // [PATCH stevilke-locila v1] robusten parse: pika = tisocica samo ob vejici (vzorec DevZnesek)
        let t = e.target.value.trim().replace(/\s/g, '');
        if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
        const v = Number(t) || 0;
        setRaw(null);
        onChange(v);
      }}
      onKeyDown={e => {
        if(e.key === 'Enter') (e.target as HTMLInputElement).blur();
      }}
      className={`bg-gray-700 border ${napaka ? 'border-red-500 ring-1 ring-red-500/60' : 'border-blue-500'} rounded px-2 py-0.5 text-white text-xs font-mono text-right outline-none ${bold ? 'font-bold' : ''} ${className}`}
    />
  );
}
